import styled from "styled-components";

export const ColorBox = styled.span<{ color: string }>`
  background-color: ${(props) => props.color};
  border: 1px solid color-mix(in hsl, ${(props) => props.color}, black 20%);
  display: inline-block;
  height: 1em;
  margin-bottom: -2px;
  width: 1.3em;
`;
